import { MK_CSS, MarketingNav, MarketingFooter, useMkNav, ArrowRight } from "./MarketingChrome";

const CSS = `
.hp-hero-inner { display:flex; flex-direction:column; align-items:center; text-align:center; }
.hp-hero-copy { width:100%; max-width:768px; margin-bottom:80px; }
.hp-hero-copy h1 { margin-bottom:24px; font-size:clamp(42px,7vw,72px); }
.hp-hero-copy p { font-size:18px; line-height:1.5; max-width:512px; margin:0 auto; }
.hp-hero-img { width:100%; aspect-ratio:16/9; }

/* logo marquee */
.hp-logos { padding:80px 0; background:#fff; overflow:hidden; }
.hp-logos-head { max-width:768px; margin:0 auto 48px; padding:0 5%; }
.hp-logos-head h2 { text-align:center; font-size:22px; font-weight:400; }
.hp-marquee-mask { overflow:hidden; }
.hp-marquee { display:flex; width:max-content; animation:hp-marquee 30s linear infinite; }
.hp-logo-item { margin:0 40px; display:flex; align-items:center; gap:10px; font-size:26px; font-weight:600; letter-spacing:-.02em; }
@keyframes hp-marquee { from{ transform:translateX(0); } to{ transform:translateX(-50%); } }
@media (prefers-reduced-motion:reduce){ .hp-marquee { animation:none; } }

/* collage */
.hp-collage { position:relative; display:flex; width:100%; min-height:420px; }
.hp-collage .c-main { margin:0 15%; width:100%; aspect-ratio:2/3; }
.hp-collage .c-left { position:absolute; bottom:10%; left:0; width:45%; aspect-ratio:3/2; z-index:2; }
.hp-collage .c-right { position:absolute; top:10%; right:0; width:40%; aspect-ratio:1/1; z-index:2; }

/* feature list */
.hp-flist { display:grid; grid-template-columns:1fr 1fr 2fr; gap:32px; }
.hp-card { display:flex; flex-direction:column; background:var(--panel); border-radius:8px; overflow:hidden; }
.hp-card > .img { width:100%; aspect-ratio:4/3; }
.hp-card .body { display:flex; flex-direction:column; padding:24px; }
.hp-card .tag { margin-bottom:8px; font-size:14px; font-weight:600; }
.hp-card h3 { margin-bottom:8px; font-size:28px; }
.hp-card p { font-size:16px; line-height:1.5; }
.hp-card-wide { display:grid; grid-template-columns:1fr 1fr; }
.hp-card-wide > .img { width:100%; height:100%; min-height:220px; }
.hp-card-wide .body { justify-content:center; padding:32px; }

/* benefits */
.hp-benefits { display:flex; gap:32px; }
.hp-benefit { position:relative; display:flex; flex-direction:column; justify-content:flex-end; flex:1; min-height:70vh;
  padding:32px; border-radius:8px; overflow:hidden; color:#fff; background:linear-gradient(160deg,#4a5d34,#263019); text-decoration:none; }
.hp-benefit .inner { position:relative; z-index:2; max-width:340px; }
.hp-benefit .tag { margin-bottom:8px; font-weight:600; font-size:16px; }
.hp-benefit h3 { font-size:36px; }
.hp-benefit p { margin-top:24px; font-size:16px; line-height:1.5; }
.hp-benefit .more { margin-top:32px; }

/* gallery */
.hp-gallery-head { text-align:center; }
.hp-gallery-head h2 { margin-bottom:24px; font-size:clamp(32px,5vw,52px); }
.hp-gallery-head p { font-size:18px; line-height:1.5; }
.hp-gallery { margin-top:64px; padding:0 5%; display:flex; gap:32px; overflow-x:auto; }
.hp-gallery::-webkit-scrollbar { display:none; }
.hp-gallery { scrollbar-width:none; }
.hp-gallery .g-img { height:560px; aspect-ratio:3/4; flex:0 0 auto; }

/* testimonials */
.hp-tcards { display:grid; grid-template-columns:repeat(3,1fr); gap:32px; }
.hp-tcard { display:flex; flex-direction:column; justify-content:space-between; background:var(--soft); border-radius:8px; padding:32px; }
.hp-tcard .brand { margin-bottom:48px; display:inline-flex; align-items:center; gap:10px; font-size:22px; font-weight:600; letter-spacing:-.02em; }
.hp-tcard .quote { font-size:18px; line-height:1.5; }
.hp-tcard .who { margin-top:24px; display:flex; align-items:center; gap:16px; }
.hp-tcard .who .av { width:48px; height:48px; min-width:48px; border-radius:50%; background:linear-gradient(135deg,#607840,#3f5229);
  display:grid; place-items:center; color:#fff; font-family:"Lexend Deca",sans-serif; font-size:18px; }
.hp-tcard .who b { font-weight:600; display:block; }
.hp-tcard .who span { font-size:16px; }

@media (max-width:900px){
  .hp-flist { grid-template-columns:1fr; }
  .hp-card-wide { grid-template-columns:1fr; }
  .hp-benefits { flex-direction:column; }
  .hp-benefit { min-height:auto; }
  .hp-tcards { grid-template-columns:1fr; }
}
`;

const WebflowMark = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="#020202" aria-hidden="true"><path d="M14.5 6.5l-2.7 6.2L9.5 6.5H6.7l-2.3 6.2L2 6.5H0l3.4 11h2.6l2.3-6 2.3 6h2.6L18.6 6.5z" /></svg>
);
const RelumeMark = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2l8.5 5v10L12 22l-8.5-5V7z" fill="#020202" /><path d="M12 2v20M3.5 7L12 12l8.5-5" stroke="#EFF1EB" strokeWidth="1.2" /></svg>
);

const MARQUEE = ["Webflow", "Relume", "Webflow", "Relume", "Webflow", "Relume"];

const BENEFITS = [
  { tag: "Clarity", h: "Managers get real spend visibility without chasing paper", p: "See exactly where the money goes. No filing cabinets, no lost invoices, no surprises at month-end." },
  { tag: "Control", h: "Chefs get accurate costing data they can trust", p: "Price a dish with confidence. Live supplier data means your margins stay sharp and your recipes stay profitable." },
  { tag: "Speed", h: "Finance teams get audit-friendly records without the chase", p: "Structured data, clear trails, and clean exports. Close the books faster and keep the auditors happy." },
];

const TESTIMONIALS = [
  { brand: "webflow", quote: "We cut invoice processing time by half and the errors just disappeared. The team actually uses it.", av: "MC", name: "Maria Chen", role: "Owner, Lula Café" },
  { brand: "relume", quote: "Month-end used to be a three-day chase. Now I pull a report and I'm done. My accountant loves me.", av: "DO", name: "David Okonkwo", role: "Finance Manager, Hart Group" },
  { brand: "webflow", quote: "I know the exact cost of every plate before it hits the pass. No guessing, just clean data.", av: "AP", name: "Ana Petrova", role: "Executive Chef, Bar Stella" },
];

export default function HomePage() {
  const nav = useMkNav();

  return (
    <div className="mk">
      <style>{MK_CSS}</style>
      <style>{CSS}</style>

      <MarketingNav active="home" />

      {/* HERO */}
      <section className="mk-sec dark">
        <div className="mk-wrap hp-hero-inner">
          <div className="hp-hero-copy">
            <h1>Clear spend visibility for your hospitality team</h1>
            <p>Capture invoices, track prices, and build accurate menu costs without the manual grind. Clean records, fast reports, zero extra admin.</p>
            <div className="mk-cta-row">
              <button className="mk-btn mk-btn-lg mk-btn-primary" onClick={nav.goSignup}>Start trial</button>
              <button className="mk-btn mk-btn-lg mk-btn-glass" onClick={nav.goFeatures}>See features</button>
            </div>
          </div>
          <div className="mk-img hp-hero-img"><span className="ph">Hospitality team · reviewing invoices</span></div>
        </div>
      </section>

      {/* LOGOS */}
      <section className="hp-logos">
        <div className="hp-logos-head"><h2>The houses that run tight ships run Bill Lens</h2></div>
        <div className="hp-marquee-mask">
          <div className="hp-marquee">
            {[0, 1].map((copy) => (
              <div style={{ display: "flex", alignItems: "center" }} key={copy} aria-hidden={copy === 1}>
                {MARQUEE.map((name, i) => (
                  <div className="hp-logo-item" key={i}>{name === "Webflow" ? <WebflowMark /> : <RelumeMark />}{name}</div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURE COLLAGE */}
      <section className="mk-sec">
        <div className="mk-wrap mk-two">
          <div>
            <h2 style={{ marginBottom: 24, fontSize: "clamp(38px,6vw,72px)" }}>Your kitchen runs on instinct. Your costs shouldn't.</h2>
            <p style={{ fontSize: 18, lineHeight: 1.5 }}>Snap an invoice with the iPad. The AI pulls supplier, totals, and line items before you finish your coffee. Review, correct, and file in seconds.</p>
            <div style={{ marginTop: 32, display: "flex", flexWrap: "wrap", gap: 16 }}>
              <button className="mk-btn mk-btn-lg mk-btn-primary" onClick={nav.goSignup}>Start trial</button>
              <button className="mk-btn mk-btn-lg mk-btn-soft" onClick={nav.goFeatures}>See features</button>
            </div>
          </div>
          <div className="hp-collage">
            <div className="mk-img c-left"><span className="ph">Capture</span></div>
            <div className="mk-img c-main"><span className="ph">On the pass</span></div>
            <div className="mk-img c-right"><span className="ph">Team</span></div>
          </div>
        </div>
      </section>

      {/* FEATURES LIST */}
      <section className="mk-sec">
        <div className="mk-wrap">
          <div className="mk-center-head">
            <p className="mk-eyebrow head" style={{ color: "var(--olive)" }}>Operate</p>
            <h2>Know your costs cold</h2>
            <p>Three tools that turn invoice data into operational control.</p>
          </div>
          <div className="hp-flist">
            <div className="hp-card">
              <div className="mk-img img"><span className="ph">Price history</span></div>
              <div className="body">
                <p className="tag">Track</p><h3>Price history</h3>
                <p>See every price change from every supplier over time.</p>
                <div style={{ marginTop: 24 }}><span className="mk-link" onClick={nav.goFeatures}>View <ArrowRight /></span></div>
              </div>
            </div>
            <div className="hp-card">
              <div className="mk-img img"><span className="ph">Menu costing</span></div>
              <div className="body">
                <p className="tag">Cost</p><h3>Menu costing</h3>
                <p>Build accurate plate costs with live supplier pricing.</p>
                <div style={{ marginTop: 24 }}><span className="mk-link" onClick={nav.goFeatures}>View <ArrowRight /></span></div>
              </div>
            </div>
            <div className="hp-card hp-card-wide">
              <div className="mk-img img"><span className="ph">Reports · Export</span></div>
              <div className="body">
                <p className="tag">Export</p><h3>One-click reports and clean data exports</h3>
                <p>Generate spend reports or export files for your accounting team.</p>
                <div style={{ marginTop: 24 }}><span className="mk-link" onClick={nav.goFeatures}>View <ArrowRight /></span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="mk-sec">
        <div className="mk-wrap">
          <div className="mk-center-head">
            <p className="mk-eyebrow head" style={{ color: "var(--olive)" }}>Results</p>
            <h2>Built for the whole house</h2>
            <p>Clean records that work for every role in the building.</p>
          </div>
          <div className="hp-benefits">
            {BENEFITS.map((b) => (
              <a className="hp-benefit" key={b.tag} onClick={nav.goFeatures} style={{ cursor: "pointer" }}>
                <div className="inner">
                  <p className="tag">{b.tag}</p>
                  <h3>{b.h}</h3>
                  <p>{b.p}</p>
                  <div className="more"><span className="mk-link" style={{ color: "#fff" }}>Learn <ArrowRight color="#fff" /></span></div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* GALLERY */}
      <section style={{ background: "#fff" }}>
        <div style={{ padding: "112px 5% 0" }}>
          <div className="mk-wrap hp-gallery-head">
            <h2>Inside Bill Lens</h2>
            <p>Clean screens built for speed and clarity in the kitchen</p>
          </div>
        </div>
        <div className="hp-gallery">
          <div className="mk-img g-img"><span className="ph">Dashboard</span></div>
          <div className="mk-img g-img"><span className="ph">Invoice review</span></div>
          <div className="mk-img g-img"><span className="ph">Reports</span></div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="mk-sec" style={{ background: "var(--cream)" }}>
        <div className="mk-wrap">
          <div style={{ marginBottom: 80 }}>
            <h2 style={{ marginBottom: 24, fontSize: "clamp(32px,5vw,52px)" }}>What operators say</h2>
            <p style={{ fontSize: 18, lineHeight: 1.5 }}>The numbers don't lie and neither do the people running the house</p>
          </div>
          <div className="hp-tcards">
            {TESTIMONIALS.map((t, i) => (
              <div className="hp-tcard" key={i}>
                <div>
                  <div className="brand">{t.brand === "webflow" ? <WebflowMark /> : <RelumeMark />}{t.brand === "webflow" ? "Webflow" : "Relume"}</div>
                  <p className="quote">“{t.quote}”</p>
                  <div className="who">
                    <div className="av">{t.av}</div>
                    <div><b>{t.name}</b><span>{t.role}</span></div>
                  </div>
                </div>
                <div style={{ marginTop: 32 }}><span className="mk-link" onClick={nav.goAbout}>Read case study <ArrowRight /></span></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="mk-sec dark">
        <div className="mk-narrow">
          <h2>Clean records start in minutes</h2>
          <p>Upload your first invoice and see the data come clean. No setup fees, no training manual required.</p>
          <div className="mk-cta-row">
            <button className="mk-btn mk-btn-lg mk-btn-primary" onClick={nav.goSignup}>Start trial</button>
            <button className="mk-btn mk-btn-lg mk-btn-glass" onClick={nav.goAbout}>Talk to us</button>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
